import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02be7bc5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=02be7bc5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be7bc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02be7bc5')) {
      api.createRecord('02be7bc5', component.options)
    } else {
      api.reload('02be7bc5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=02be7bc5&scoped=true", function () {
      api.rerender('02be7bc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/productAppConfig/productConfig/trafficGroupRule/index.vue"
export default component.exports